import Icon from '../components/Icon';

const RailTrail = Icon(
  'rail-trail',
  <>
    <path
      fillRule="evenodd"
      d="M11.675 5.998a3.876 3.876 0 0 1 7.65 0 4.189 4.189 0 0 1-1.012 8.252H16.25V17h-1.5v-2.75h-2.062a4.187 4.187 0 0 1-1.013-8.252m6.2.627v.005a.75.75 0 0 0 .683.756 2.688 2.688 0 0 1-.245 5.364H16.25v-1.287l2.085-1.042a.75.75 0 1 0-.67-1.342l-1.415.707V8.5a.75.75 0 0 0-1.5 0v4.25h-2.062a2.687 2.687 0 1 1 0-5.375h.937a.75.75 0 0 0 0-1.5h-.38a2.376 2.376 0 0 1 4.63.75M7.25 8.25c0 1.259-.846 2.32-2 2.646V17h-1.5v-6.103A2.751 2.751 0 0 1 4.5 5.5a2.75 2.75 0 0 1 2.75 2.75M4.5 7a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
      clipRule="evenodd"
    />
    <path d="M1.25 18.25A.75.75 0 0 1 2 17.5h20a.75.75 0 0 1 0 1.5h-3.765l1.39 2.084a.75.75 0 0 1-1.249.832L16.432 19h-3.697l1.39 2.084a.75.75 0 0 1-1.249.832L10.932 19H7.235l1.39 2.084a.75.75 0 0 1-1.249.832L5.432 19H2a.75.75 0 0 1-.75-.75" />
  </>
);

export default RailTrail;
